import { ApiClient } from '@/lib/axios/client';
import type {
  TeamMember,
  CreateTeamMemberDto,
  UpdateTeamMemberDto,
  TeamFilters,
  MemberNudges,
} from './types';
import type { PaginatedData } from '@/lib/axios/types';

const BASE_PATH = '/api/v1/team';

export class TeamApi {
  static async getTeamMembers(filters: TeamFilters): Promise<PaginatedData<TeamMember>> {
    return await ApiClient.get<PaginatedData<TeamMember>>(BASE_PATH, {
      params: filters,
    });
  }

  static async createTeamMembers(data: CreateTeamMemberDto): Promise<PaginatedData<TeamMember>> {
    return await ApiClient.post<PaginatedData<TeamMember>>(BASE_PATH, data);
  }

  static async updateTeamMembers(data: UpdateTeamMemberDto): Promise<PaginatedData<TeamMember>> {
    return await ApiClient.patch<PaginatedData<TeamMember>>(BASE_PATH, data);
  }

  static async updateTeamMember(
    userId: string,
    data: UpdateTeamMemberDto
  ): Promise<PaginatedData<TeamMember>> {
    return await ApiClient.patch<PaginatedData<TeamMember>>(
      `${BASE_PATH}/${userId}`,
      data
    );
  }

  static async deleteTeamMember(userId: string): Promise<void> {
    await ApiClient.delete<TeamMember>(`${BASE_PATH}/${userId}`);
  }

  /**
   * Replaces a member's complete reminder subscription set. Positive ids are
   * org-level nudges, negative ids chatbot-level — the same convention the
   * `calendar` field uses on the way in.
   */
  static async setMemberNudges(userId: string, nudgeIds: number[]): Promise<MemberNudges> {
    return await ApiClient.put<MemberNudges>(`${BASE_PATH}/${userId}/nudges`, {
      nudge_ids: nudgeIds,
    });
  }
}